import { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

export default function useSendNotifications() {
  const BASE_URL = useSelector((state) => state.BASE_URL);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendNotifications = async (date, responsibleIds) => {
    setIsLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('fleetToken');
      const formattedDate = moment(date).format('YYYY-MM-DD');

      const response = await fetch(
        `${BASE_URL}/responsibles/send-notifications`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
          body: JSON.stringify({
            date: formattedDate,
            responsible_ids: responsibleIds,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Erreur lors de l'envoi");
      }

      const data = await response.json();
      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    sendNotifications,
    isLoading,
    error,
  };
}

